const el = document.getElementById('js-modal-dialog');

if (el) {
    const closeButton = el.querySelector('.js-dialog-close');
    const timer = el.querySelector('.timer');
    const accessibleTimer = el.querySelector('.at-timer');
    const fallback = document.querySelector('.govuk-timeout-warning-fallback');
    const warningTextPrefix =
        (el.querySelector('.dialog-text-prefix') || {}).textContent || '';
    const warningTextSuffix = '.';
    const warningText =
        (el.querySelector('.dialog-text') || {}).textContent || '';

    const secondsSessionTimeout =
        parseInt(el.dataset.sessionTimeout, 10) || 1800;
    const secondsTimeoutWarning =
        parseInt(el.dataset.sessionTimeoutWarning, 10) || 300;
    const unitMinute = el.dataset.unitMinute || 'menit';
    const unitSecond = el.dataset.unitSecond || 'detik';

    let timers = [];
    let lastFocusedEl = null;
    let timeSessionRefreshed = new Date();

    function isConfigured() {
        return (
            timer &&
            accessibleTimer &&
            secondsSessionTimeout &&
            secondsTimeoutWarning
        );
    }

    function isDialogOpen() {
        return el.open;
    }

    function makePageContentInert() {
        const content = document.querySelector('#content');
        if (content) {
            content.inert = true;
            content.setAttribute('aria-hidden', 'true');
        }
    }

    function removeInertFromPageContent() {
        const content = document.querySelector('#content');
        if (content) {
            content.inert = false;
            content.setAttribute('aria-hidden', 'false');
        }
    }

    function openDialog() {
        if (!isDialogOpen()) {
            document.documentElement.classList.add('dialog-is-open');
            lastFocusedEl = document.querySelector(':focus') || null;
            makePageContentInert();
            el.showModal();
        }
    }

    function refreshSession() {
        fetch('', { method: 'GET' });
        timeSessionRefreshed = new Date();
        controller();
    }

    function closeDialog() {
        if (isDialogOpen()) {
            document.documentElement.classList.remove('dialog-is-open');
            el.close();
            if (lastFocusedEl) {
                setTimeout(() => lastFocusedEl.focus(), 0);
            }
            removeInertFromPageContent();
            refreshSession();
        }
    }

    function clearTimers() {
        timers.forEach(clearInterval);
        timers = [];
    }

    function addTimer(fn, seconds) {
        timers.push(setInterval(fn, seconds * 1000));
    }

    function secondsSinceRefresh() {
        return Math.round(Math.abs((timeSessionRefreshed - new Date()) / 1000));
    }

    function secondsUntilSessionTimeout() {
        return secondsSessionTimeout - secondsSinceRefresh();
    }

    function secondsUntilTimeoutWarning() {
        return secondsUntilSessionTimeout() - secondsTimeoutWarning;
    }

    function numericSpan(n, unit) {
        return '<span class="tabular-numbers">' + n + '</span> ' + unit;
    }

    function startCountdown() {
        const iOS =
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        function countdown() {
            const remaining = secondsUntilSessionTimeout();
            if (remaining <= 0) return;

            const minutesLeft = Math.floor(remaining / 60);
            const secondsLeft = Math.floor(remaining % 60);

            const countdownHtml =
                minutesLeft > 0
                    ? numericSpan(minutesLeft, unitMinute)
                    : numericSpan(secondsLeft, unitSecond);

            timer.innerHTML =
                warningTextPrefix +
                '<strong>' +
                countdownHtml +
                '</strong>' +
                warningTextSuffix +
                '<p>' +
                warningText +
                '</p>';

            if (!iOS && remaining % 20 === 0) {
                const atCount =
                    minutesLeft > 0
                        ? minutesLeft + ' ' + unitMinute
                        : secondsLeft + ' ' + unitSecond;
                accessibleTimer.textContent =
                    warningTextPrefix +
                    atCount +
                    warningTextSuffix +
                    ' ' +
                    warningText;
            }
        }

        countdown();
        addTimer(countdown, 1);
    }

    function redirect() {
        window.location.reload();
    }

    function tick() {
        console.log(
            'Session timeout in',
            secondsUntilSessionTimeout(),
            'seconds — popup in',
            secondsUntilTimeoutWarning(),
            'seconds',
        );
    }

    function controller() {
        clearTimers();
        const remaining = secondsUntilSessionTimeout();
        addTimer(tick, 10);

        if (remaining <= 0) {
            redirect();
        } else if (remaining <= secondsTimeoutWarning) {
            openDialog();
            startCountdown();
            addTimer(controller, remaining);
        } else {
            addTimer(controller, secondsUntilTimeoutWarning());
        }
    }

    function init() {
        if (!isConfigured()) return;

        if (typeof HTMLDialogElement !== 'function') {
            if (fallback) fallback.style.display = 'block';
            return;
        }

        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            closeDialog();
        });

        document.addEventListener('keydown', (e) => {
            if (isDialogOpen() && e.key === 'Escape') {
                closeDialog();
            }
        });

        controller();
    }

    init();
}
